import { css } from 'styled-components';

const MainText = css`
  font: ${props => props.theme.fontWeightDccc} 14px/16px ${props => props.theme.fontFamilyBody};
  letter-spacing: 0.1px;
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
`;

const SecondaryText = css`
  ${MainText};
  font-size: 10px;
`;

const RankNumber = css`
  font: ${props => props.theme.fontWeightHeavy} 16px/16px ${props => props.theme.fontFamilyBody};
  letter-spacing: 0.1px;
`;

export {
  MainText,
  RankNumber,
  SecondaryText,
};
